import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { ClientAuthService } from '../../services/auth/client-auth.service';
import { User } from 'oidc-client-ts';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { environment } from 'projects/reg-hub-admin/src/environments/environment';

@Component({
  selector: 'app-top-menubar',
  templateUrl: './top-menubar.component.html',
  styleUrls: ['./top-menubar.component.css'],
  animations: [
    trigger('toggleSidenav', [
      state('sidenav-open', style({
        backgroundColor: 'white'
      })),
      state('sidenav-closed', style({
        backgroundColor: 'var(--color-primary)'
      })),
      transition('sidenav-open <=> sidenav-closed', animate('250ms ease-in-out'))
    ])
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class TopMenubarComponent {
  @Input() isSidenavOpen: boolean = true;
  @Output() isSidenavOpenChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  protected readonly showLanguageSelector = environment.urlAddress.includes("dev") || environment.urlAddress.includes("localhost");

  username: string = "";
  userAuthenticated: boolean = false;

  constructor(private router: Router,
    private authService: ClientAuthService) { }

  ngOnInit(): void {
    if (this.authService.isLoggedIn()) {
      this.userAuthenticated = true;
      this.username = this.authService.getUserNameFromToken() ?? "";
    }
  }

  toggleSidenav() {
    this.isSidenavOpen = !this.isSidenavOpen;
    this.isSidenavOpenChange.emit(this.isSidenavOpen);
  }

  navigateHome() {
    this.router.navigate(['/dashboard']);
  }

  navigateToMyAccount() {
    this.router.navigate(['/my-account']);
  }

  logIn(): void {
    this.authService.logIn();
  }

  logOut() {
    this.authService.logOut();
  }
}
